import { Children, useState } from "react";
import { AddIcon, ScreenRecordingIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function ScreenRecordings() {
  const [recordingList, setRecordingList] = useState([
    "[Screen RecordingTitle]",
    "[Screen RecordingTitle]",
    "[Screen RecordingTitle]",
    "[Screen RecordingTitle]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Content</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            recordingList.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/screen-recordings/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setRecordingList(() => [
                      ...recordingList,
                      `Copy of ${data}`,
                    ]);
                  }}
                  onDelete={() => {
                    setRecordingList(() =>
                      recordingList.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <ScreenRecordingIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
